import { volunteerBenefits } from '../../../mocks/volunteerData';

export default function BenefitsSection() {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-2 md:mb-4">
            志愿者权益
          </h2>
          <p className="text-sm md:text-lg text-[#6C6C6C]">
            我们珍视每一位志愿者的付出，为您提供全方位保障
          </p>
        </div>

        <div className="grid grid-cols-3 lg:grid-cols-3 gap-3 md:gap-8">
          {volunteerBenefits.map((benefit, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row items-center md:items-start p-3 md:p-6 bg-[#F9F9F9] rounded-lg md:rounded-xl hover:bg-white hover:shadow-lg transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-14 md:h-14 bg-[#2A7A62] rounded-lg flex items-center justify-center flex-shrink-0 mb-2 md:mb-0">
                <i className={`${benefit.icon} text-lg md:text-2xl text-white`}></i>
              </div>
              <div className="md:ml-4 text-center md:text-left">
                <h3 className="text-xs md:text-lg font-bold text-[#1E1E1E] mb-1 md:mb-2">
                  {benefit.title}
                </h3>
                <p className="text-[9px] md:text-sm text-[#6C6C6C]">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-16 bg-gradient-to-r from-[#2A7A62] to-[#236B54] rounded-xl md:rounded-2xl p-6 md:p-12 text-center text-white">
          <h3 className="text-xl md:text-3xl font-bold mb-2 md:mb-4">
            更多惊喜等您发现
          </h3>
          <p className="text-sm md:text-lg opacity-90 mb-4 md:mb-8">
            加入点滴公益志愿者团队，收获成长、友谊与感动
          </p>
          <div className="flex items-center justify-center gap-4 md:gap-8">
            <div className="flex flex-col md:flex-row items-center">
              <i className="ri-heart-fill text-2xl md:text-3xl text-[#F4B942] mb-1 md:mb-0 md:mr-3"></i>
              <div className="text-center md:text-left">
                <div className="text-base md:text-2xl font-bold">温暖</div>
                <div className="text-[10px] md:text-sm opacity-80">传递爱心</div>
              </div>
            </div>
            <div className="w-px h-8 md:h-12 bg-white/30"></div>
            <div className="flex flex-col md:flex-row items-center">
              <i className="ri-team-fill text-2xl md:text-3xl text-[#F4B942] mb-1 md:mb-0 md:mr-3"></i>
              <div className="text-center md:text-left">
                <div className="text-base md:text-2xl font-bold">团队</div>
                <div className="text-[10px] md:text-sm opacity-80">志同道合</div>
              </div>
            </div>
            <div className="w-px h-8 md:h-12 bg-white/30"></div>
            <div className="flex flex-col md:flex-row items-center">
              <i className="ri-star-fill text-2xl md:text-3xl text-[#F4B942] mb-1 md:mb-0 md:mr-3"></i>
              <div className="text-center md:text-left">
                <div className="text-base md:text-2xl font-bold">成长</div>
                <div className="text-[10px] md:text-sm opacity-80">提升自我</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}